module.exports = __webpack_public_path__ + "img/caranec-eshop.fe4ccb1f.png";